import React, { Component } from 'react';
import Notifications2, {notify} from 'react-notify-toast';
import InputMask from 'react-input-mask';
import Dropzone from 'react-dropzone';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';
import './stripe.connect.css';

@inject('userStore')
class SettingsBusiness extends Component {
    constructor(props){
        super(props);
        this.state = {
            business:null,
            sys_state_list:[],
            uploadVisible:false
        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.saveBusiness = this.saveBusiness.bind(this);
    }

    componentDidMount(){
        this.setState({business:this.props.business, sys_state_list:this.props.sys_state_list})
    }

    handleInputChange(e) {
        let updated_business = Object.assign({}, this.state.business);
        updated_business[e.target.name] = e.target.value;
        this.setState({business:updated_business});
    }

    saveBusiness(){
        let updated_business = Object.assign({}, this.state.business);
        delete updated_business["bus_srv_list"];
        delete updated_business["bus_srv_cat_list"];
        delete updated_business["bus_user_list"];
        delete updated_business["bus_lineitem_list"];
        delete updated_business["bus_payment_option_list"];
        post('/v2/save/business', {business:updated_business},{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                notify.show(res.data.message, "success", 3000);
            } else {
                notify.show(res.data.message, "error", 1000);
            }
        }).catch((error) => {
            notify.show(error, "error", 1000);
            console.log(error);
            return error;
        });
    }


    fileUpload(){
        const formData = new FormData();
        formData.append('file',this.state.files[0])
        formData.append('id', this.state.business.id)
        formData.append('typeof', 'business')
        post('/v2/upload/media', formData,{
            auth: {username: this.props.userStore.token}
        }).then((res) => {
            if (res.data.errors === 0){
                // set the new thumb image
                let temp_business = Object.assign([], this.state.business);
                temp_business.thumb = res.data.src;
                this.setState({
                    business:temp_business,
                    uploadVisible:!this.state.uploadVisible
                })
                console.log('call notify')
                notify.show(res.data.message, "success", 1000);
                console.log('called notify')
            } else {
                notify.show(res.data.message, "error", 1000);
            }
        }).catch((error) => {
            notify.show("Error occurred", "error", 1000);
            console.log(error);
            return error;
        });
    }


    onDrop = (files) => {
        console.log(files)
        this.setState({
            files:files
        }, ()=>this.fileUpload());
    }

    onCancel() {
    }

    openUpload = () => {
        this.setState({
            uploadVisible:!this.state.uploadVisible
        })
    }


    render(){
        const dropzone = {
            'position': 'relative',
            'width': '200px',
            'height': '200px',
            'borderWidth': '2px',
            'borderColor': 'rgb(102, 102, 102)',
            'borderStyle': 'dashed',
            'borderRadius': '5px',
            marginTop: '15px',
            marginRight: 'auto',
            marginBottom: 0,
            marginLeft: 'auto',
        };
        if (!this.state.business) return <div className="alert alert-info">Loading...</div>;
        const {business, sys_state_list} = this.state;
        return (
        <React.Fragment>
          <Notifications2 options={{wrapperId:'business-notifications'}}/>
            <div className="card form-type-combine">
                <h4 className="card-title"><strong>General Information</strong></h4>
                <div className="card-body">
                    <div className="card card-inverse mb-0">
                        <div className="card-body text-center pb-20 pt-20">
                            <img src={business.thumb} className="avatar avatar-xxl avatar-bordered" />
                            <br/>
                            <button className="btn btn-sm btn-primary mt-15" onClick={this.openUpload}>{this.state.uploadVisible ? "Close" : "Upload New Thumb"}</button>
                        <Dropzone
                            multiple={false}
                            onDrop={this.onDrop}
                            className={this.state.uploadVisible ? "" : "d-none"}
                            style={dropzone}
                            onFileDialogCancel={this.onCancel}>
                            <p>Drop a new image file here, or click to select file to upload.</p>
                      </Dropzone>
                        </div>
                    </div>

                    <div className="form-groups-attached">
                        <div className="row">
                            <div className="form-group col-12">
                                <label>Business name</label>
                                <input className="form-control" type="text" name="name" value={business.name} onChange={this.handleInputChange}/>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Description</label>
                            <textarea className="form-control" name="description" style={{height:200+"px"}} value={business.description} onChange={this.handleInputChange}></textarea>
                        </div>
                    </div>
                </div>
                <h4 className="card-title"><strong>Contact Information</strong></h4>
                <div className="card-body">
                    <div className="form-groups-attached">
                        <div className="row">
                            <div className="form-group col-6">
                                <label>Primary Phone</label>
                                <InputMask className="form-control" mask="(999)-999-9999" maskChar=" " name="phone_primary" value={business.phone_primary} onChange={this.handleInputChange} />
                            </div>
                            <div className="form-group col-6">
                                <label>Mobile Phone</label>
                                <InputMask className="form-control" mask="(999)-999-9999" maskChar=" " name="phone_mobile" value={business.phone_mobile} onChange={this.handleInputChange} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-6">
                                <label>Contact Email</label>
                                <input className="form-control" type="text" name="contact_email" value={business.contact_email} onChange={this.handleInputChange}/>
                            </div>
                            <div className="form-group col-6">
                                <label>Website URL</label>
                                <input className="form-control" type="text" name="website_url" value={business.website_url} onChange={this.handleInputChange}/>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Email Signature</label>
                            <textarea className="form-control" name="email_signature" value={business.email_signature} onChange={this.handleInputChange}></textarea>
                        </div>
                    </div>
                </div>
                <h4 className="card-title"><strong>Address Information</strong></h4>
                <div className="card-body">
                    <div className="form-groups-attached">
                        <div className="row">
                            <div className="form-group col-6">
                                <label>Address</label>
                                <input className="form-control" type="text" name="address1" value={business.address1} onChange={this.handleInputChange}/>
                            </div>
                            <div className="form-group col-6">
                                <label>Address 2</label>
                                <input className="form-control" type="text" name="address2" value={business.address2} onChange={this.handleInputChange}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="form-group col-6">
                                <label>City</label>
                                <input className="form-control" type="text" name="city" value={business.city} onChange={this.handleInputChange}/>
                            </div>
                            <div className="form-group col-2">
                                <label>State</label>
                                <select className="form-control" name="sys_state_id" value={business.sys_state_id} onChange={this.handleInputChange}>
                                {sys_state_list.map((state, index) =>
                                    <option key={index} value={state.id}>{state.abbr}</option>
                                )}
                                </select>
                            </div>
                            <div className="form-group col-4">
                                <label>Postal Code</label>
                                <input className="form-control" type="text" name="postal_code" value={business.postal_code} onChange={this.handleInputChange}/>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="card-footer text-right">
                    <button className="btn btn-secondary" type="reset">Cancel</button>
                    <button className="btn btn-primary" type="button" onClick={this.saveBusiness}>Submit</button>
                </footer>
            </div>
        </React.Fragment>
        );
    }
}

export default SettingsBusiness;



// WEBPACK FOOTER //
// ./src/components/business/SettingsBusiness.js